import Lenis from 'lenis'
import {hideMenu} from "./menuToggle";

export function smoothScroll(btn) {
  const lenis = new Lenis({
    autoRaf: true,
  });

  btn.addEventListener('click', () => {
    lenis.scrollTo(0.4, {
      easing: (t) => 0.5 * (Math.sin((t - 0.5) * Math.PI) + 1),
    });
  });

  window.addEventListener('keydown', (event) => {
    const isEditable = ['INPUT', 'TEXTAREA'].includes(event.target.tagName) || event.target.isContentEditable;

    if (!isEditable  && event.code === 'Space') {
      event.preventDefault();
    }
  });

  const header = document.querySelector('.header');
  const navbarToggler = header?.querySelector('.nav-toggler');
  const animalsSection = document.querySelector('#_animals');

  document.addEventListener('click', (e) => {
    const { target } = e;
    const href = target.getAttribute("href");
    const tag = target.tagName;
    const isBodyContainsLock = document.body.classList.contains('disable-scroll');

    if (e.target && e.target.classList.contains('location')) {
      if (!e.target.classList.contains('active')) return;
      const targetSection = document.querySelector('.interactive-map__info');
      if (targetSection) {
        lenis.scrollTo(targetSection, { duration: 0.4,easing: (t) => 0.5 * (Math.sin((t - 0.5) * Math.PI) + 1) });
      }
    }

    if (target && target.closest('#_animals') && target.closest('button')) {
      e.stopPropagation();
      const targetPosition = window.pageYOffset + animalsSection.getBoundingClientRect().top;
      lenis.scrollTo(targetPosition, { duration: 0.4, easing: (t) => 0.5 * (Math.sin((t - 0.5) * Math.PI) + 1) });
    }

    if (!href || tag === 'use') return;

    const urlWithoutHash = window.location.href.split('#')[0];
    const hrefWithoutHash = href.split('#')[0];
    const containsHash = href.split('#')[1];

    if (containsHash && (urlWithoutHash === hrefWithoutHash || hrefWithoutHash.length === 0)) {
      e.preventDefault();

      const targetElement = document.getElementById(containsHash);
      if (!targetElement) return;

      const targetPosition = window.pageYOffset + targetElement.getBoundingClientRect().top;

      if (isBodyContainsLock) {
        hideMenu(navbarToggler, header);
        setTimeout(() => {
          lenis.scrollTo(targetPosition, { duration: 0.4, easing: (t) => 0.5 * (Math.sin((t - 0.5) * Math.PI) + 1) });
        }, 300);
      } else {
        lenis.scrollTo(targetPosition, { duration: 0.4,easing: (t) => 0.5 * (Math.sin((t - 0.5) * Math.PI) + 1) });
      }
    }
  });

  return lenis;
}
